import { render, staticRenderFns } from "./ItemActions.vue?vue&type=template&id=2089251e&"
import script from "./ItemActions.vue?vue&type=script&lang=ts&"
export * from "./ItemActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports